import type { FaireProductEntity } from "../../entity_types/product";

export const p_bzvcsu372d: FaireProductEntity = {
  token: "p_bzvcsu372d",
  type: "product",
  name: "Custom Youth Hooded Sweatshirt",
  brandToken: "b_n9fwmzzqs5",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/598c00c1e2653452547932039d4ad258444d28e9518943ff184418d446222bcc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9f9bf915140e9ceb45f5003525b095f22ad8837dc7e3c68259a6c0bca6eb40a7.jpeg",
    "https://cdn.faire.com/fastly/565f5c68f4725db12026aa28726a845eb9447a51e7d3bdef607d8bc6fb5a18f8.jpeg",
    "https://cdn.faire.com/fastly/c2268736f927ac2d7dc484e103c60e972bda27a61042ba64309c9a371677cb0a.jpeg",
    "https://cdn.faire.com/fastly/a723a75a636a9a5261bf981a7e37e0830b9d02e140bf60d158609215ed46ae2b.jpeg",
  ],
  priceDollars: 34.58,
  description:
    "Custom Youth Sweatshirt /Hooded Sweatshirt \n\n👍Personalize these ultra comfy tees with your logo, artwork or words in any single print \n \n✌️If you have artwork, message us your image file before purchase to be sure we can get a good \n     print from it. We can print multi color designs!\n  👍We will send you a proof/mockup to approve, and make any adjustments, before printing. \n👌Keep in mind that we will not print anything copyrighted or trademarked. \n ** Toddler Fleece Crewneck Sweatshirt**\n7.5 oz./yd² (US), 12.5 oz./L yd (CA), 60/40 cotton/polyester\nWhite is sewn with 100% cotton thread\nCoverstitched collar, shoulders, armholes, ribbed cuffs and waistband\nCPSIA compliant tracking label on side seam\n\n👕 Unmatched Softness: Dive into a world of unparalleled comfort with our supremely soft fabric. Each touch is a gentle embrace, ensuring you feel relaxed all day long.\n\n",
  tags: [],
  msrpDollars: 69.15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:19.030Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
